export const EN_LANG = "en";
export const PROJECT_LANG = process.env.REACT_APP_LANG_KEY || EN_LANG;
export const LANG_STORAGE_KEY = "nfl_pick_em_lang";

export const isLanguageToggleEnabled = PROJECT_LANG !== EN_LANG;

export const SUPPORTED_LANGS = [PROJECT_LANG, EN_LANG];

const getLangFromStorage = (): string | null => {
	try {
		return window.localStorage.getItem(LANG_STORAGE_KEY);
	} catch {
		return null;
	}
};

export const getCurrentLang = (): string => {
	const search = new URLSearchParams(window.location.search);
	const fromUrl = search.get("lang");

	if (fromUrl) {
		return fromUrl;
	}

	if (!isLanguageToggleEnabled) {
		return PROJECT_LANG;
	}

	const fromStorage = getLangFromStorage();

	if (fromStorage && SUPPORTED_LANGS.includes(fromStorage)) {
		return fromStorage;
	}

	return PROJECT_LANG;
};

export const storeLanguage = (lang: string): void => {
	try {
		window.localStorage.setItem(LANG_STORAGE_KEY, lang);
	} catch {
		return;
	}
};

export const reloadWithLanguage = (lang: string): void => {
	const url = new URL(window.location.href);
	url.searchParams.set("lang", lang);
	window.location.assign(url.toString());
};
